import React from 'react'
import GamePassMember from './GamePassMember'

const Approvals = () => {
  return <GamePassMember />
}

export default Approvals
